import React from 'react';
import { Button, Dialog, DialogContent, DialogActions, DialogContentText, DialogTitle } from '@material-ui/core';
import _ from 'lodash';
import { useMutation } from '@apollo/react-hooks';
import { DependencyDisplay } from './DependencyDisplay';

const DeleteDialog = ({
  open,
  handleClose,
  variables,
  deleteEntityMutation,
  entityIsLineup,
  onDelete,
  dependencyStructure,
  entityId,
  type,
  refetchData,
  refetchCount,
}) => {
  const safeRefetchData = refetchData || (() => {});
  const safeRefetchCount = refetchCount || (() => {});

  const [deleteEntity] = useMutation(deleteEntityMutation, {
    onError: err => {},
    onCompleted: () => {
      if (entityIsLineup) return onDelete();
    },
  });

  const handleAccept = async () => {
    await deleteEntity({
      variables,
    });
    safeRefetchData();
    safeRefetchCount();
    handleClose();
  };

  const checkEntityDependencies = _.isEmpty(dependencyStructure);

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description">
      {checkEntityDependencies ? (
        <>
          <DialogTitle id="alert-dialog-slide-title"> Delete this record ?</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <span style={{ fontWeight: 'bold' }}>Warning!</span> this action can not be undone{' '}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleAccept} className="clear-button">
              Yes
            </Button>
            <Button onClick={handleClose} color="primary">
              No
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogTitle id="alert-dialog-slide-title"> You must delete the following entities first</DialogTitle>
          <DialogContent>
            <DependencyDisplay
              dependencyStructure={dependencyStructure}
              type={type}
              entityId={entityId}
              onClose={handleClose}
              showDescription={false}
              refetchData={safeRefetchData}
              refetchCount={safeRefetchCount}
            />
          </DialogContent>
        </>
      )}
    </Dialog>
  );
};

export { DeleteDialog };
